import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { VehicleUsagesService } from 'src/app/shared/api-services/vehicle-usages.service';
import { BookingService } from 'src/app/shared/api-services/booking.service';
import { VehicleUsagesFilter } from 'src/app/shared/models/vehicle-usages/vehicle-usage-filter';
import { VehicleUsage } from 'src/app/shared/models/vehicle-usages/vehicle-usages';
import { BookingsFilter } from 'src/app/shared/models/booking/booking-filter';
import { Booking } from 'src/app/shared/models/booking/booking';
import { Subject, finalize, forkJoin, takeUntil } from 'rxjs';
import * as StatusBooking from 'src/app/shared/constant/status-booking';

export interface VehicleUsageCheckModalData {
  vehicleId: string;
  startDate: string;
  endDate: string;
}

@Component({
  selector: 'vehicle-usage-check-modal',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule
  ],
  templateUrl: './vehicle-usage-check-modal.component.html',
  styleUrls: ['./vehicle-usage-check-modal.component.scss']
})
export class VehicleUsageCheckModalComponent implements OnInit {
  @Input() data: VehicleUsageCheckModalData;
  @Output() onContinue = new EventEmitter<boolean>();

  vehicleUsages: VehicleUsage[] = [];
  bookings: Booking[] = [];
  loading = false;
  hasConflicts = false;
  hasBookingConflicts = false;

  private _destroy$ = new Subject<void>();

  constructor(
    public modalRef: BsModalRef,
    private _vehicleUsagesService: VehicleUsagesService,
    private _bookingService: BookingService
  ) { }

  ngOnInit(): void {
    this.checkConflicts();
  }

  private checkConflicts(): void {
    if (!this.data?.vehicleId || !this.data?.startDate) {
      return;
    }

    this.loading = true;
    
    const usageParams: VehicleUsagesFilter = {
      vehicleId: this.data.vehicleId,
      rangeStartDate: this.data.startDate,
      rangeEndDate: this.data.endDate,
      includeVehicle: true,
      includeUser: true
    };

    const bookingParams: BookingsFilter = {
      vehicleId: this.data.vehicleId,
      rangeStart: this.data.startDate,
      rangeEnd: this.data.endDate,
      includeUser: true,
      includeVehicle: true,
      includeHeadquarter: true,
      includeLocation: true,
      statusList: [StatusBooking.STATUS_OK, StatusBooking.STATUS_OK_ACTIVE, StatusBooking.STATUS_OK_DELAYED]
    };

    // Utilizzo forkJoin per eseguire entrambe le chiamate in parallelo
    forkJoin({
      usages: this._vehicleUsagesService.listVehicleUsages$(usageParams),
      bookings: this._bookingService.listBookings$(bookingParams)
    })
    .pipe(
      takeUntil(this._destroy$),
      finalize(() => this.loading = false)
    )
    .subscribe({
      next: (response) => {
        this.vehicleUsages = response.usages.items;
        this.bookings = response.bookings.items;
        
        this.hasConflicts = this.vehicleUsages.length > 0;
        this.hasBookingConflicts = this.bookings.length > 0;
      }
    });
  }

  continueAnyway(): void {
    this.onContinue.emit(true);
    this.modalRef.hide();
  }

  cancel(): void {
    this.onContinue.emit(false);
    this.modalRef.hide();
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
} 